import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { UitkPill, UitkRemovablePill } from 'uitk-react-pill';

import { amenityLegacyEquals } from 'utils/amenity-mapper';

import { stringify } from 'query-string';

export interface PlaybackFilterPillProps {
  pill: PillProps;
  routeStore?: RouteStore;
  analytics?: any;
  defaults?: any;
  disabled: boolean;
  removable: boolean;
  checked?: boolean;
}

export interface PillProps {
  query?: string;
  name: string;
  label: string;
  value: any;
  generated: boolean; // Only set by BEX API
}

export interface PlaybackFilterPillState {
  hide: boolean;
  checked: boolean;
}

export const PlaybackFilterPill: React.FunctionComponent<PlaybackFilterPillProps> = props => {
  const [hide, setHide] = React.useState(false);
  const [checked, setChecked] = React.useState(props.checked);

  React.useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  const { analytics, defaults, disabled, pill, routeStore, removable } = props;

  if (hide || !pill || !pill.label) {
    return null;
  }

  const { name, label, value } = pill;

  const sendTracking = () => {
    const suffix = `playback.${name}.${value}`;

    analytics.clickTracker(`.${suffix}`, suffix)();
  };

  const dismissPillAndUpdateSearch = () => {
    sendTracking();
    updateSearchForDismiss();
    setHide(true);
    logAdRefresh('remove');
  };

  const togglePillAndUpdateSearch = () => {
    sendTracking();

    if (checked) {
      updateSearchForDismiss();
    } else {
      const currentParams = { ...routeStore.queryParams };
      const singleOptionFilters = ['regionId', 'poi', 'sort'];
      let filteredParams = currentParams[pill.name];
      if (filteredParams instanceof Array) {
        filteredParams.push(pill.value);
      } else if (!singleOptionFilters.includes(pill.name) && filteredParams && filteredParams.length > 0) {
        filteredParams = [filteredParams, pill.value];
      } else {
        filteredParams = pill.value;
      }
      currentParams[pill.name] = filteredParams;
      routeStore.updateSearch(stringify(currentParams));
    }
    setChecked(!checked);
    logAdRefresh('toggle');
  };

  const updateSearchForDismiss = () => {
    if (pill.query && pill.query.length > 0) {
      routeStore.updateSearch(pill.query);
    } else if (pill.generated) {
      // BEX API does not return pills urls. Instead we can calculate which param to remove from
      // the information we already have
      const currentParams = { ...routeStore.queryParams };
      const dismissValue = pill.value;
      const isPriceFilter = pill.name === 'price';
      const isMultiplePriceFiltersSelected = dismissValue && dismissValue.toString().indexOf(',') >= 0;
      if (isPriceFilter && isMultiplePriceFiltersSelected) {
        currentParams[pill.name] = '';
        routeStore.updateSearch(stringify(currentParams));
      } else if (defaults && defaults[pill.name]) {
        currentParams[pill.name] = defaults[pill.name];
        routeStore.updateSearch(stringify(currentParams));
      } else {
        const preFilteredParams = currentParams[pill.name];
        let filteredParams;
        if (preFilteredParams instanceof Array) {
          filteredParams = preFilteredParams.filter(pillValue => !amenityLegacyEquals(pillValue, dismissValue));
        } else {
          filteredParams = amenityLegacyEquals(preFilteredParams, dismissValue) ? '' : preFilteredParams;
        }
        currentParams[pill.name] = filteredParams;
        routeStore.updateSearch(stringify(currentParams));
      }
    }
  };

  const logAdRefresh = type => {
    if (document && document.dispatchEvent && typeof document.dispatchEvent === 'function' && CustomEvent) {
      document.dispatchEvent(new CustomEvent('mesoSlotFilterUpdate', { detail: { type: 'slotFilter', editType: type, filterData: pill } }));
    }
  };

  const valueId = typeof value === 'string' ? value.replace(/,/g, '-') : value;
  const key = `playback-filter-pill-${name}-${valueId}`;

  if (removable) {
    return (
      <UitkRemovablePill id={key} key={key} onClick={dismissPillAndUpdateSearch} disabled={disabled}>
        <span className="playback-pill-grid-item-label">{label}</span>
      </UitkRemovablePill>
    );
  } else {
    return (
      <UitkPill id={key} key={key} onChange={togglePillAndUpdateSearch} disabled={disabled} checked={checked}>
        <span className="playback-pill-grid-item-label">{label}</span>
      </UitkPill>
    );
  }
};
PlaybackFilterPill.displayName = 'PlaybackFilterPill';
